<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />
    <div class="mb-3">
      <div class="row">
        <div class="col-11"><h4>Facturas</h4></div>
        <div class="col-1">
          <span class="material-symbols-outlined" style="font-size:32px;color:blue;cursor:pointer"
            @click="showModalHelp = true">help</span>
        </div>
      </div>
    </div>
    <Modal v-model:modelValue="showModalHelp">
      <AyudaFactura />
    </Modal>
    <hr>

    <!-- Búsqueda -->
    <div class="mb-3">
      <table class="tablaBusqueda">
        <tr>
          <td>
            <label class="form-label">Número</label>
            <input type="text" class="form-control" v-model="numeroBusqueda"
              @input="clearFields('numero')" style="width:150px;text-transform:uppercase">
          </td>
          <td>
            <label class="form-label">Cédula</label>
            <input type="text" class="form-control" v-model="cedulaBusqueda"
              @input="clearFields('cedula')" style="width:150px;text-transform:uppercase">
          </td>
          <td>
            <label class="form-label">Nombre</label>
            <input type="text" class="form-control" v-model="nombreBusqueda"
              @input="clearFields('nombre')" style="width:350px;text-transform:uppercase">
          </td>
          <td>
            <button class="btn btn-light" @click.prevent="buscar" title="Buscar">
              <i class="material-icons" style="font-size:24px;color:blue;cursor:pointer">search</i>
            </button>
          </td>
        </tr>
      </table>
    </div>

    <DataTable
      :data="facturas"
      :columns="columnas"
      idField="idFactura"
      :mostrarBotonNuevo="false"
      :mostrarInfo="false"
      :mostrarEditar="false"
      :mostrarVer="false"
      :mostrarEliminar="false"
      :mostrarBotonExcel="false"
      @refresh="getDataTodos"
    >
      <!-- Botón CSV -->
      <template #acciones-extra>
        <div class="col-auto">
          <button class="btn btn-success btn-sm d-flex align-items-center gap-1"
            @click="downloadDataAsCsv" title="Generar Archivo CSV">
            <span class="material-symbols-outlined" style="font-size:16px">file_save</span>
            CSV
          </button>
        </div>
      </template>

      <!-- Fecha formateada -->
      <template #cell-fechaEmision="{ row }">
        {{ getFormattedDate(row.fechaEmision, 'DD/MM/YYYY') }}
      </template>

      <!-- Estado legible -->
<template #cell-estadoFactura="{ row }">
  <span class="badge" :class="badgeEstadoFactura(row.estadoFactura)">
    {{ row.estadoFactura }}
  </span>
</template>

      <!-- Select de acciones por fila -->
      <template #acciones-fila="{ row }">
        <button
          class="btn btn-sm btn-outline-primary"
          @click="abrirEditar(row.idFactura)"
          title="Ver detalles"
        >
          <i class="material-icons" style="font-size:14px">receipt_long</i>
        </button>
<!--		
        <button
          class="btn btn-sm btn-outline-danger"
          @click="deleteFactura(row.idFactura)"
          title="Borrar"
        >
          <i class="material-icons" style="font-size:14px">delete</i>
        </button>
-->		
      </template>
    </DataTable>

    <!-- Modal editar -->
    <div class="modal fade" id="ventanaModal" tabindex="-1"
      aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title">
              <i class="fa fa-user-plus"></i> {{ titulo }}
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <form>
            <div class="modal-body">
              <div class="mb-3" v-if="btnEditar">
                <div class="row">
                  <div class="col-2"><label class="form-label">IdFactura</label></div>
                  <div class="col-10">
                    <input type="text" class="form-control" v-model="datoFactura.idFactura" disabled>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label">Persona</label></div>
                  <div class="col-10">
                    <select class="form-control" v-model="datoFactura.idPersona">
                      <option v-for="persona in personas" :value="persona.idPersona" :key="persona.idPersona">
                        {{ persona.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label">IdUsuarioReg</label></div>
                  <div class="col-10">
                    <input type="text" class="form-control" v-model="datoFactura.idUsuarioReg"
                      style="text-transform:uppercase" required>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label">IdUsuarioAct</label></div>
                  <div class="col-10">
                    <input type="text" class="form-control" v-model="datoFactura.idUsuarioAct"
                      style="text-transform:uppercase" required>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label">FechaReg</label></div>
                  <div class="col-10">
                    <input type="text" class="form-control" v-model="datoFactura.fechaReg" disabled>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label">FechaAct</label></div>
                  <div class="col-10">
                    <input type="date" class="form-control" v-model="datoFactura.fechaAct" required>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label">Fecha Emisión</label></div>
                  <div class="col-10">
                    <input type="date" class="form-control" v-model="datoFactura.fechaEmision" required>
                  </div>
                </div>
              </div>
              <div class="mb-3" v-if="btnEditar">
                <div class="row">
                  <div class="col-2"><label class="form-label">EstadoFactura</label></div>
                  <div class="col-10">
                    <input type="text" class="form-control" v-model="datoFactura.estadoFactura"
                      style="text-transform:uppercase" required>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label">Total</label></div>
                  <div class="col-10">
                    <input type="text" class="form-control" v-model="datoFactura.total"
                      style="text-transform:uppercase" required>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="modal-footer">
            <button class="btn btn-light" @click.prevent="guardarEditFactura" v-if="btnEditar" title="Actualizar">
              <i class="material-icons" style="font-size:32px;color:blue;cursor:pointer">update</i>
            </button>
            <button class="btn btn-light" @click.prevent="guardarEditFacturaEstado" v-if="btnEditar">
              Listo
            </button>
          </div>
        </div>
      </div>
    </div>

    <Footer/>
  </div>
</template>

<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
import DataTable from '@/components/DataTable.vue'
import AyudaFactura from '@/views/ayuda/AyudaFactura.vue'
import { validarForm } from '@/modules/validacionesForms.js'
import dateFormat from '@/modules/dateFormat.js'
import { exportToCsv } from '@/modules/exportDatos.js'
import api from '@/services/api'
import * as $ from 'jquery'
window['$'] = $
window['jQuery'] = $
import swal from 'sweetalert'

export default {
  components: { Layout, Footer, DataTable, AyudaFactura },

  data() {
    return {
      facturas: [],
      datoFactura: {},
      numeroBusqueda: '',
      cedulaBusqueda: '',
      nombreBusqueda: '',
      titulo: '',
      btnEditar: false,
      modalWindow: true,
      personas: [],
      showModalHelp: false,

columnas: [
  { field: 'numero',        label: 'Número' },
  { field: 'fechaEmision',  label: 'Fecha Emisión' },
  {
    field: 'estadoFactura',
    label: 'Estado',
    filterType: 'select',
    filterOptions: [
//      { value: '',          label: 'Todos'     },
      { value: 'PENDIENTE', label: 'Pendiente' },
      { value: 'EMITIDA',   label: 'Emitida'   },
      { value: 'PARCIAL',   label: 'Parcial'   },
      { value: 'PAGADA',    label: 'Pagada'    },
      { value: 'ANULADA',   label: 'Anulada'   },
    ],
  },
  { field: 'personaNombre', label: 'Receptor' },
  { field: 'total',         label: 'Total'    },
],
    }
  },

  mounted() {
    this.getDataTodos()
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
    this.fetchPersonas()
  },

  methods: {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date)
    },

    badgeEstadoFactura(estado) {
      const clases = {
        'PENDIENTE': 'bg-warning  text-dark',
        'EMITIDA':   'bg-success  text-white',
        'ANULADA':   'bg-danger   text-white',
      };
      return clases[estado] ?? 'bg-secondary text-white';
    },

    clearFields(activeField) {
      if (activeField !== 'numero') this.numeroBusqueda = ''
      if (activeField !== 'cedula') this.cedulaBusqueda = ''
      if (activeField !== 'nombre') this.nombreBusqueda = ''
    },

    buscar() {
      const idEmpresa = window.sessionStorage.getItem('idEmpresa')
      let url = ''
      if (this.numeroBusqueda)
        url = `/vwfacturas/numero/${idEmpresa}/${this.numeroBusqueda}`
      else if (this.cedulaBusqueda)
        url = `/vwfacturas/cedula/${idEmpresa}/${this.cedulaBusqueda}`
      else if (this.nombreBusqueda)
        url = `/vwfacturas/nombre/${idEmpresa}/${this.nombreBusqueda}`
      if (url) {
        api.get(url)
          .then(r => { this.facturas = r.data.reverse() })
          .catch(e => console.error('Error en búsqueda:', e))
      }
    },

    getDataTodos() {
      this.numeroBusqueda = ''
      this.cedulaBusqueda = ''
      this.nombreBusqueda = ''
      api.get('/vwfacturas/idempresa/' + window.sessionStorage.getItem('idEmpresa'))
        .then(r => { this.facturas = r.data.reverse() })
        .catch(e => console.error('Error cargando facturas:', e))
    },

    handleAction(event, idFactura) {
      const action = event.target.value
      if (action === 'detalles')       this.abrirEditar(idFactura)
      else if (action === 'borrar')    this.deleteFactura(idFactura)
      event.target.value = 'Seleccione...'
    },

    validarForm() {
      const fields = ['idPersona', 'fechaEmision', 'estadoFactura', 'total']
      return validarForm(this.datoFactura, fields, fields)
    },

    async guardarEditFactura() {
      if (this.validarForm() === 1) {
        try {
          this.datoFactura.idUsuarioAct = window.sessionStorage.getItem('idUsuarioAct')
          await api.post('/facturas', this.datoFactura)
          $('#ventanaModal').modal('hide')
          this.getDataTodos()
          swal('Correcto!', 'Factura actualizada exitosamente!', 'success')
        } catch (error) {
          swal('Error!', 'Intentelo de nuevo!', 'error')
          Object.values(error.response.data.errors).forEach(e => swal(String(e)))
        }
      }
    },

    async guardarEditFacturaEstado() {
      if (this.validarForm() === 1) {
        try {
          this.datoFactura.estadoFactura = 'PENDIENTE'
          await api.post('/facturas', this.datoFactura)
          $('#ventanaModal').modal('hide')
          this.getDataTodos()
          swal('Correcto!', 'Factura actualizada exitosamente!', 'success')
        } catch (error) {
          swal('Error!', 'Intentelo de nuevo!', 'error')
          Object.values(error.response.data.errors).forEach(e => swal(String(e)))
        }
      }
    },

    abrirEditar(idFactura) {
      if (idFactura != null) {
        this.$router.push({
          path: '/facturaform',
          state: { idFactura }
        });	  
      }
    },
/*
    async deleteFactura(idFactura) {
      try {
        await api.delete('/facturas/' + idFactura)
        this.getDataTodos()
      } catch (error) {
        alert('No se pudo eliminar')
      }
    },
*/
    fetchPersonas() {
      api.get('/vwpersonas')
        .then(r => { this.personas = r.data })
        .catch(e => console.error('Error fetching personas:', e))
    },

    downloadDataAsCsv() {
      const headers = ['idFactura', 'numero', 'fechaEmision', 'estadoFactura', 'personaNombre', 'total']
      exportToCsv('facturas.csv', this.facturas, headers)
    },
  },
}
</script>

<style src="@/assets/css/listaFiltrada.css" scoped></style>